/* Linore theme: plain JS, no dependencies. Everything degrades to normal
   links and form posts without it. */
(() => {
  const L = window.Linore || { routes: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = L.moneyFormat || "₹{{amount}}";
    const n = Number(cents) / 100;
    const withDec = n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = Math.round(n).toLocaleString("en-IN");
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec)
      .replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/<[^>]+>/g, "")
      .replace(/\.00(?!\d)/, ""); // match Liquid's money_without_trailing_zeros
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return false;
    closeMega();
    lastFocus = document.activeElement;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    const focusable = $("input[type=search], [data-drawer-close]:not(.ln-drawer__scrim), button, a", $(".ln-drawer__panel", d));
    setTimeout(() => focusable && focusable.focus(), 60);
    return true;
  }
  function closeDrawer(d) {
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    if (!$(".ln-drawer.is-open")) document.documentElement.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      if (openDrawer(opener.dataset.drawerOpen)) e.preventDefault();
      return;
    }
    const closer = e.target.closest("[data-drawer-close]");
    if (closer) closeDrawer(closer.closest(".ln-drawer"));
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const open = $$(".ln-drawer.is-open").pop();
    if (open) closeDrawer(open);
    closeMega();
  });

  /* ---------- Header: scroll border + mega menus ---------- */
  const header = $("[data-header]");
  let closeTimer;
  function closeMega() {
    $$("[data-mega].is-open").forEach((m) => m.classList.remove("is-open"));
    $$("[data-mega-toggle]").forEach((b) => b.setAttribute("aria-expanded", "false"));
    header && header.classList.remove("has-open");
  }
  function openMega(i) {
    clearTimeout(closeTimer);
    $$("[data-mega]").forEach((m) => m.classList.toggle("is-open", m.dataset.mega === String(i)));
    $$("[data-mega-toggle]").forEach((b) => b.setAttribute("aria-expanded", String(b.dataset.megaToggle === String(i))));
    header && header.classList.toggle("has-open", !!i);
  }
  if (header) {
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    $$("[data-menu-item]", header).forEach((li) => {
      li.addEventListener("mouseenter", () => (li.querySelector("[data-mega-toggle]") ? openMega(li.dataset.menuItem) : closeMega()));
    });
    $$("[data-mega]", header).forEach((m) => m.addEventListener("mouseenter", () => clearTimeout(closeTimer)));
    header.addEventListener("mouseleave", () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, 160);
    });
    $$("[data-mega-toggle]", header).forEach((b) =>
      b.addEventListener("click", () => (b.getAttribute("aria-expanded") === "true" ? closeMega() : openMega(b.dataset.megaToggle)))
    );
  }

  /* ---------- Announcement rotation ---------- */
  $$("[data-announce]").forEach((bar) => {
    const items = $$("p", bar);
    if (items.length < 2 || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 4500);
  });

  /* ---------- Cart (AJAX API + Section Rendering) ---------- */
  async function refreshCart(open = true) {
    const res = await fetch(`${L.routes.root}?sections=ln-cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data["ln-cart-drawer"], "text/html");
    const fresh = $("[data-cart-panel]", html);
    const panel = $("[data-cart-panel]");
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    loadCartRecs();
    const count = Number($("[data-cart-count-text]", html)?.textContent || 0);
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.classList.toggle("hidden", count === 0);
    });
    if (open) openDrawer("ln-cart");
  }
  /* "Pairs well with" in the drawer: related to the first line, minus what is already in the bag. */
  let recsFor = null;
  async function loadCartRecs() {
    const slot = $("[data-cart-recs]");
    if (!slot || !slot.dataset.productId || !L.routes.recommendations) return;
    try {
      const url = `${L.routes.recommendations}?section_id=ln-cart-recs&product_id=${slot.dataset.productId}&limit=6&intent=related`;
      const res = await fetch(url);
      const html = new DOMParser().parseFromString(await res.text(), "text/html");
      const body = $("[data-cart-recs-body]", html);
      if (!body) return;
      const inBag = new Set($$("[data-cart-handle]").map((li) => li.dataset.cartHandle));
      $$("[data-rec-handle]", body).forEach((li) => inBag.has(li.dataset.recHandle) && li.remove());
      $$("[data-rec-handle]", body).slice(3).forEach((li) => li.remove());
      const any = $$("[data-rec-handle]", body).length > 0;
      slot.innerHTML = any ? body.innerHTML : "";
      slot.hidden = !any;
      recsFor = slot.dataset.productId;
    } catch {
      slot.hidden = true;
    }
  }
  document.addEventListener("click", (e) => {
    const slot = $("[data-cart-recs]");
    if (e.target.closest('[data-drawer-open="ln-cart"]') && slot && recsFor !== slot.dataset.productId) loadCartRecs();
  });

  async function addToCart(id, quantity = 1) {
    const res = await fetch(`${L.routes.cartAdd}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || "Could not add to bag");
    await refreshCart(true);
  }
  document.addEventListener("click", async (e) => {
    const change = e.target.closest("[data-line-change]");
    if (change) {
      change.disabled = true;
      await fetch(`${L.routes.cartChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: Number(change.dataset.lineChange), quantity: Number(change.dataset.qty) }),
      });
      await refreshCart(false);
      return;
    }
    const quickOpen = e.target.closest("[data-quick-open]");
    if (quickOpen) {
      const wrap = quickOpen.closest("[data-quick-add]");
      quickOpen.classList.add("hidden");
      $("[data-quick-sizes]", wrap).classList.replace("hidden", "flex");
      return;
    }
    const add = e.target.closest("[data-add-variant]");
    if (add && !add.disabled) {
      add.disabled = true;
      try {
        await addToCart(add.dataset.addVariant);
      } catch (err) {
        alert(err.message);
      }
      add.disabled = false;
    }
  });

  /* ---------- Product page ---------- */
  $$("[data-product]").forEach((root) => {
    const id = root.dataset.product;
    const json = $(`[data-product-json="${id}"]`);
    const form = $("[data-product-form]", root);
    if (!json || !form) return;
    const { variants, stock = {}, threshold = 0 } = JSON.parse(json.textContent);
    const stockNote = $("[data-stock-note]", root);
    const noUrl = root.hasAttribute("data-no-url");
    // Real inventory only: "stock" lists tracked, non-overselling variants.
    function showStock(v) {
      if (!stockNote) return;
      const q = v && stock[v.id];
      stockNote.textContent = v && v.available && q > 0 && q <= threshold ? `Only ${q} left in this size.` : "";
    }
    const idInput = $("[data-variant-id]", form);
    const atc = $("[data-atc]", form);
    const atcLabel = $("[data-atc-label]", form);
    const error = $("[data-form-error]", form);
    const fieldsets = $$("fieldset[data-option-index]", form);
    const sticky = document.querySelector("[data-sticky-atc]");

    const selected = () => fieldsets.map((fs) => $("input[data-option]:checked", fs)?.value);
    const match = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

    function update() {
      const opts = selected();
      const v = match(opts);
      fieldsets.forEach((fs, i) => {
        const label = $("[data-selected-value]", fs);
        if (label) label.textContent = opts[i] || "";
        // Mark values that have no available variant with the other current picks.
        $$("input[data-option]", fs).forEach((input) => {
          const trial = opts.slice();
          trial[i] = input.value;
          const tv = match(trial);
          input.nextElementSibling?.classList.toggle("is-unavailable", !tv || !tv.available);
        });
      });
      if (!v) {
        atc.disabled = true;
        atcLabel.textContent = "Unavailable";
        return;
      }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? "Add to bag" : "Sold out";
      const priceEl = $("[data-price-current]", root);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      const cmp = $("[data-price-compare]", root);
      if (cmp) cmp.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : "";
      const sp = sticky && $("[data-sticky-price]", sticky);
      if (sp) sp.textContent = formatMoney(v.price);
      showStock(v);
      if (!noUrl) {
        const url = new URL(location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url);
      }
      if (v.featured_media) {
        $$(`[data-media-id="${v.featured_media.id}"]`, root).forEach((el) => {
          const track = el.closest("[data-gallery-track]");
          if (track) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: "smooth" });
        });
      }
    }
    form.addEventListener("change", (e) => e.target.matches("[data-option]") && update());
    showStock(variants.find((v) => String(v.id) === idInput.value));

    // Remember this product for "Recently viewed".
    if (root.dataset.recent) {
      try {
        const list = JSON.parse(localStorage.getItem("ln-recent") || "[]").filter((h) => h !== root.dataset.recent);
        localStorage.setItem("ln-recent", JSON.stringify([root.dataset.recent, ...list].slice(0, 12)));
      } catch {}
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      error.classList.add("hidden");
      atc.disabled = true;
      try {
        await addToCart(idInput.value);
      } catch (err) {
        error.textContent = err.message;
        error.classList.remove("hidden");
      }
      atc.disabled = false;
    });

    // Mobile gallery counter
    const track = $("[data-gallery-track]", root);
    const idx = $("[data-gallery-index]", root);
    if (track && idx) {
      track.addEventListener("scroll", () => (idx.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1), { passive: true });
    }

    // Sticky mobile bar: visible once the real button has scrolled above the screen.
    // The root is extended far below the screen so a jump from bottom to top still flips it.
    const anchor = $("[data-atc-anchor]", root);
    if (sticky && anchor && "IntersectionObserver" in window) {
      // It also steps aside once the footer's bottom row scrolls in, so it never covers those links.
      let anchorSeen = true;
      let footerSeen = false;
      const sync = () => {
        const show = !anchorSeen && !footerSeen;
        sticky.classList.toggle("is-visible", show);
        sticky.setAttribute("aria-hidden", String(!show));
        $("[data-sticky-go]", sticky).tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(
        ([entry]) => {
          anchorSeen = entry.isIntersecting;
          sync();
        },
        { rootMargin: "0px 0px 100000px 0px" }
      ).observe(anchor);
      const footer = $("[data-footer-base]") || $("footer");
      if (footer)
        new IntersectionObserver(([entry]) => {
          footerSeen = entry.isIntersecting;
          sync();
        }).observe(footer);
      $("[data-sticky-go]", sticky).addEventListener("click", () => {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
        if (!atc.disabled) form.requestSubmit();
      });
    }
  });

  /* ---------- Delivery estimate (working days Mon–Sat) ---------- */
  function addWorkingDays(from, days) {
    const d = new Date(from);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) days--;
    }
    return d;
  }
  $$("[data-delivery-check]").forEach((form) => {
    const input = $("[data-pincode]", form);
    const out = $("[data-delivery-result]", form);
    input.addEventListener("input", () => (input.value = input.value.replace(/\D/g, "").slice(0, 6)));
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!/^[1-9][0-9]{5}$/.test(input.value)) {
        out.innerHTML = '<span class="text-destructive">Enter a 6-digit pincode.</span>';
        return;
      }
      const { dispatch = 1, min = 3, max = 6 } = L.delivery || {};
      const f = new Intl.DateTimeFormat("en-IN", { weekday: "short", day: "numeric", month: "short" });
      const shipped = addWorkingDays(new Date(), dispatch);
      out.innerHTML = `Estimated delivery: <span class="font-medium">${f.format(addWorkingDays(shipped, min))} – ${f.format(addWorkingDays(shipped, max))}</span>`;
    });
  });

  /* ---------- Recommendations (lazy) ---------- */
  $$("[data-recommendations][data-url]").forEach((el) => {
    const load = async () => {
      const res = await fetch(el.dataset.url);
      const html = new DOMParser().parseFromString(await res.text(), "text/html");
      const fresh = $("[data-recommendations]", html);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    };
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(([e]) => e.isIntersecting && (io.disconnect(), load()), { rootMargin: "400px" });
      io.observe(el);
    } else load();
  });

  /* ---------- Predictive search ---------- */
  $$("[data-predictive-input]").forEach((input) => {
    const scope = input.closest("[data-searchbar]") || input.closest(".ln-drawer__panel");
    const results = scope && scope.querySelector("[data-predictive-results]");
    if (!results) return;
    const initial = results.innerHTML;
    let t;
    input.addEventListener("input", () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!q) return (results.innerHTML = initial);
      t = setTimeout(async () => {
        const url = `${L.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=ln-predictive-search&resources[type]=product&resources[limit]=6`;
        const res = await fetch(url);
        const html = new DOMParser().parseFromString(await res.text(), "text/html");
        const body = $("[data-predictive-body]", html);
        if (body && input.value.trim() === q) results.innerHTML = body.innerHTML;
      }, 220);
    });
  });

  /* ---------- Tabs ---------- */
  $$("[data-tabs]").forEach((wrap) => {
    wrap.addEventListener("click", (e) => {
      const tab = e.target.closest("[data-tab]");
      if (!tab) return;
      $$("[data-tab]", wrap).forEach((t) => t.setAttribute("aria-selected", String(t === tab)));
      $$("[role=tabpanel]", wrap).forEach((p) => (p.hidden = p.id !== `panel-${tab.dataset.tab}`));
    });
  });

  /* ---------- Collection: sort auto-submit + grid density ---------- */
  $$("[data-autosubmit]").forEach((s) => s.addEventListener("change", () => s.form.submit()));
  const grid = $("[data-density-grid]");
  if (grid) {
    const apply = (n) => {
      grid.classList.remove("lg:grid-cols-2", "lg:grid-cols-3", "lg:grid-cols-4");
      grid.classList.add(`lg:grid-cols-${n}`);
      $$("[data-density]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.density === String(n))));
    };
    let saved = 4;
    try {
      saved = Number(localStorage.getItem("ln-grid")) || 4;
    } catch {}
    apply(saved);
    $$("[data-density]").forEach((b) =>
      b.addEventListener("click", () => {
        apply(b.dataset.density);
        try {
          localStorage.setItem("ln-grid", b.dataset.density);
        } catch {}
      })
    );
  }

  /* ---------- Hero carousel ---------- */
  function initHero(hero) {
    if (hero.dataset.ready) return;
    hero.dataset.ready = "1";
    const slides = $$("[data-slide]", hero);
    const tabs = $$("[data-hero-tab]", hero);
    const current = $("[data-hero-current]", hero);
    const toggle = $("[data-hero-toggle]", hero);
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let autoplay = hero.dataset.autoplay !== "false" && !reduced && slides.length > 1;
    const pauses = new Set(autoplay ? [] : ["off"]);
    let index = 0;
    // Carousels without progress tabs (the campaign slideshow) run on a plain timer.
    const intervalMs = (parseFloat(hero.dataset.interval) || 6) * 1000;
    let timer;
    function schedule() {
      clearTimeout(timer);
      if (autoplay && !tabs.length && pauses.size === 0) timer = setTimeout(() => go(index + 1), intervalMs);
    }

    const pad = (n) => String(n).padStart(2, "0");
    function syncPaused() {
      hero.classList.toggle("is-paused", pauses.size > 0);
      schedule();
      if (!toggle) return;
      const stopped = pauses.has("user") || pauses.has("off");
      toggle.setAttribute("aria-label", stopped ? "Play slideshow" : "Pause slideshow");
      $("[data-icon-pause]", toggle).classList.toggle("hidden", stopped);
      $("[data-icon-play]", toggle).classList.toggle("hidden", !stopped);
    }
    function restartFill() {
      const fill = tabs[index] && $(".ln-hero__fill", tabs[index]);
      if (!fill) return;
      fill.style.animation = "none";
      void fill.offsetWidth; // force reflow so the animation starts over
      fill.style.animation = "";
    }
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        const on = n === index;
        s.classList.toggle("is-active", on);
        s.toggleAttribute("inert", !on);
        s.setAttribute("aria-hidden", String(!on));
        $$("[data-slide-link]", s).forEach((a) => (on ? a.removeAttribute("tabindex") : a.setAttribute("tabindex", "-1")));
      });
      tabs.forEach((t, n) => {
        t.classList.toggle("is-active", n === index);
        t.setAttribute("aria-selected", String(n === index));
      });
      hero.dataset.tone = slides[index].dataset.tone || "dark";
      if (current) current.textContent = pad(index + 1);
      restartFill();
      schedule();
      // Warm up the next slide so it never fades in blank.
      const next = slides[(index + 1) % slides.length];
      // Only images laid out at this screen size (skip the hidden phone/desktop variant).
      $$('img[loading="lazy"]', next).filter((img) => img.offsetParent).forEach((img) => (img.loading = 'eager'));
    }

    // The active tab's fill animation is the timer: when it finishes, advance.
    hero.addEventListener("animationend", (e) => {
      if (autoplay && e.target.classList.contains("ln-hero__fill") && e.target.closest("[data-hero-tab]") === tabs[index]) go(index + 1);
    });
    tabs.forEach((t, n) => t.addEventListener("click", () => go(n)));
    $("[data-hero-prev]", hero)?.addEventListener("click", () => go(index - 1));
    $("[data-hero-next]", hero)?.addEventListener("click", () => go(index + 1));
    toggle?.addEventListener("click", () => {
      if (pauses.has("off")) {
        // Autoplay was off in settings: the visitor asked for it, so start it.
        pauses.delete("off");
        autoplay = slides.length > 1;
        hero.dataset.autoplay = "true";
      }
      else if (pauses.has("user")) pauses.delete("user");
      else pauses.add("user");
      if (!pauses.size) restartFill();
      syncPaused();
    });

    const hold = (why, on) => {
      if (on === pauses.has(why)) return; // no change: keep the running timer (repeat events used to reset it)
      on ? pauses.add(why) : pauses.delete(why);
      syncPaused();
    };
    // Hover pause is for a real mouse only: on phones a tap fires a fake mouseenter that would
    // hold the slideshow until the next tap elsewhere.
    hero.addEventListener("pointerenter", (e) => e.pointerType === "mouse" && hold("hover", true));
    hero.addEventListener("pointerleave", (e) => e.pointerType === "mouse" && hold("hover", false));
    hero.addEventListener("focusin", () => hold("focus", true));
    hero.addEventListener("focusout", (e) => !hero.contains(e.relatedTarget) && hold("focus", false));
    document.addEventListener("visibilitychange", () => hold("hidden", document.hidden));
    hero.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") go(index + 1);
      if (e.key === "ArrowLeft") go(index - 1);
    });

    // Swipe on touch: horizontal flicks change slide; vertical scrolling is left alone.
    let x0 = null;
    let y0 = null;
    hero.addEventListener("touchstart", (e) => {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    hero.addEventListener("touchend", (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) go(index + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });

    // Theme editor: selecting a slide block shows it and holds it there.
    document.addEventListener("shopify:block:select", (e) => {
      const slide = e.target.closest && e.target.closest("[data-slide]");
      if (slide && hero.contains(slide)) {
        go(Number(slide.dataset.slide));
        hold("editor", true);
      }
    });
    document.addEventListener("shopify:block:deselect", () => hold("editor", false));

    syncPaused();
    go(0);
  }
  $$("[data-hero]").forEach(initHero);
  document.addEventListener("shopify:section:load", (e) => $$("[data-hero]", e.target).forEach(initHero));

  /* ---------- Card stack (drag / swipe / arrows) ---------- */
  function stackConfig(w) {
    if (w < 640) return { dist: 120, vel: 500, sens: 180, x: 90, y: 20, rot: 8, scale: 0.06, max: 1 }; // phones: one card per swipe
    if (w < 1024) return { dist: 160, vel: 650, sens: 220, x: 130, y: 30, rot: 10, scale: 0.09 };
    return { dist: 200, vel: 800, sens: 250, x: 170, y: 40, rot: 12, scale: 0.12 };
  }
  function initStack(stage) {
    if (stage.dataset.ready) return;
    const cards = $$("[data-stack-card]", stage);
    const n = cards.length;
    if (n < 2) return;
    stage.dataset.ready = "1";
    stage.classList.add("is-ready");
    const section = stage.closest("section");
    const controls = $("[data-stack-controls]", section);
    const count = $("[data-stack-count]", section);
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let cfg = stackConfig(innerWidth);
    let p = 0, v = 0, target = 0, raf = 0, last = 0, active = -1;

    // Signed distance of card i from the front, wrapped so the stack loops.
    const wrap = (i, at) => {
      let d = (i - at) % n;
      if (d > n / 2) d -= n;
      if (d < -n / 2) d += n;
      return d;
    };
    const pad = (x) => String(x).padStart(2, "0");

    function render() {
      cards.forEach((card, i) => {
        const o = wrap(i, p);
        const a = Math.abs(o);
        const still = a < 0.05;
        const x = o * cfg.x;
        const y = still ? 0 : a * cfg.y;
        const r = still ? 0 : o * cfg.rot;
        const s = 1 - a * cfg.scale;
        const edge = n / 2 - 0.5;
        card.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${r}deg) scale(${s})`;
        card.style.opacity = a > edge ? Math.max(0, (n / 2 - a) / 0.5) : 1;
        card.style.zIndex = Math.round(100 - a * 10);
        card.style.setProperty("--front", Math.max(0, 1 - a / 0.5));
        card.style.setProperty("--dim", a <= 0.5 ? a * 0.4 : Math.min(0.5, 0.2 + (a - 0.5) * 0.2));
      });
      const now = ((Math.round(p) % n) + n) % n;
      if (now !== active) {
        active = now;
        cards.forEach((card, i) => {
          const front = i === active;
          card.tabIndex = front ? 0 : -1;
          card.toggleAttribute("aria-hidden", !front);
        });
        if (count) count.textContent = `${pad(active + 1)} / ${pad(n)}`;
      }
    }

    function step(t) {
      const dt = last ? Math.min(0.032, (t - last) / 1000) : 1 / 60;
      last = t;
      // Spring: stiffness 200, damping 30, mass 1.
      v += (-200 * (p - target) - 30 * v) * dt;
      p += v * dt;
      if (Math.abs(p - target) < 0.001 && Math.abs(v) < 0.01) {
        p = target;
        v = 0;
        raf = 0;
        last = 0;
        render();
        return;
      }
      render();
      raf = requestAnimationFrame(step);
    }
    function settle(to) {
      target = to;
      if (reduced) {
        p = to;
        v = 0;
        render();
        return;
      }
      if (!raf) raf = requestAnimationFrame(step);
    }
    function stop() {
      cancelAnimationFrame(raf);
      raf = 0;
      last = 0;
      v = 0;
    }

    // Drag / swipe. Horizontal moves spin the stack; vertical moves still scroll the page.
    let drag = null;
    let suppressClick = false;
    stage.addEventListener("dragstart", (e) => e.preventDefault());
    stage.addEventListener("pointerdown", (e) => {
      if (e.button !== 0) return;
      stop();
      drag = { x: e.clientX, start: p, lastX: e.clientX, lastT: e.timeStamp, vel: 0, moved: false };
    });
    addEventListener("pointermove", (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) {
        drag.moved = true;
        stage.classList.add("is-dragging");
      }
      if (!drag.moved) return;
      const dt = e.timeStamp - drag.lastT;
      if (dt > 0) drag.vel = 0.8 * ((e.clientX - drag.lastX) / dt) * 1000 + 0.2 * drag.vel;
      drag.lastX = e.clientX;
      drag.lastT = e.timeStamp;
      p = drag.start - dx / cfg.sens;
      render();
    });
    function release(e) {
      if (!drag) return;
      const d = drag;
      drag = null;
      stage.classList.remove("is-dragging");
      if (!d.moved) return;
      // Swallow the click that follows a drag (if the drag ended off the stack, no click comes).
      suppressClick = true;
      setTimeout(() => (suppressClick = false), 0);
      const dx = e.clientX - d.x;
      const max = cfg.max || 3;
      let shift = Math.max(-max, Math.min(max, Math.round(-dx / cfg.dist - d.vel / cfg.vel)));
      if (shift === 0 && Math.abs(dx) > 40 && cfg.max) shift = dx < 0 ? 1 : -1; // a clear swipe always moves
      settle(Math.round(d.start) + shift);
    }
    addEventListener("pointerup", release);
    addEventListener("pointercancel", (e) => {
      if (!drag) return;
      drag = null;
      stage.classList.remove("is-dragging");
      settle(Math.round(p));
    });

    // A tap on a side card brings it forward; a tap on the front card opens it.
    stage.addEventListener(
      "click",
      (e) => {
        if (suppressClick) {
          suppressClick = false;
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const card = e.target.closest("[data-stack-card]");
        if (!card) return;
        const i = cards.indexOf(card);
        if (i !== active) {
          e.preventDefault();
          settle(Math.round(p + wrap(i, p)));
        }
      },
      true
    );
    stage.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") settle(Math.round(target) + 1);
      else if (e.key === "ArrowLeft") settle(Math.round(target) - 1);
      else return;
      e.preventDefault();
      // Keep keyboard focus on the front card as it changes.
      if (cards.includes(document.activeElement)) requestAnimationFrame(() => cards[active].focus({ preventScroll: true }));
    });
    if (controls) {
      controls.hidden = false;
      $("[data-stack-prev]", controls).addEventListener("click", () => settle(Math.round(target) - 1));
      $("[data-stack-next]", controls).addEventListener("click", () => settle(Math.round(target) + 1));
    }
    addEventListener("resize", () => {
      cfg = stackConfig(innerWidth);
      render();
    });
    render();
  }
  $$("[data-stack]").forEach(initStack);
  document.addEventListener("shopify:section:load", (e) => $$("[data-stack]", e.target).forEach(initStack));

  /* ---------- Photo pile (drag the top photo to the back) ---------- */
  function initPile(stage) {
    if (stage.dataset.ready) return;
    const cards = $$("[data-pile-card]", stage);
    const n = cards.length;
    if (n < 2) return;
    stage.dataset.ready = "1";
    stage.classList.add("is-ready");
    const section = stage.closest("section");
    const captions = $$("[data-pile-caption]", section);
    const shop = $("[data-pile-shop]", section);
    const nextBtn = $("[data-pile-next]", section);
    const hint = $("[data-pile-hint]", section);
    const order = cards.map((_, i) => i);
    const DEPTH = 4; // cards deeper than this sit hidden behind the fourth
    let busy = false;

    // Nudge the whole pile so it looks centred (cards fan up and to the left).
    const spread = Math.min(n - 1, DEPTH);
    stage.style.transform = `translate(${spread * 6}px, ${spread * 4}px)`;

    function layout() {
      order.forEach((ci, pos) => {
        const card = cards[ci];
        const d = Math.min(pos, DEPTH);
        card.style.setProperty("--x", `${d * -12}px`);
        card.style.setProperty("--y", `${d * -8}px`);
        card.style.setProperty("--r", pos === 0 ? "0deg" : `${-(2 + d * 3)}deg`);
        card.style.zIndex = 100 - pos;
        card.style.opacity = pos > DEPTH ? 0 : 1;
        const top = pos === 0;
        card.classList.toggle("is-top", top);
        card.tabIndex = top ? 0 : -1;
        card.toggleAttribute("aria-hidden", !top);
      });
      const top = order[0];
      captions.forEach((cap, i) => (cap.hidden = i !== top));
      if (shop) shop.href = cards[top].getAttribute("href");
    }
    function next() {
      if (busy) return;
      busy = true;
      order.push(order.shift());
      layout();
      setTimeout(() => (busy = false), 300);
    }

    // Drag the top card. Past 50px it goes to the back; otherwise it springs home.
    const elastic = (d) => (Math.abs(d) <= 150 ? d : Math.sign(d) * (150 + (Math.abs(d) - 150) * 0.2));
    let drag = null;
    let suppressClick = false;
    stage.addEventListener("dragstart", (e) => e.preventDefault());
    stage.addEventListener("pointerdown", (e) => {
      const card = e.target.closest("[data-pile-card]");
      if (e.button !== 0 || !card || card !== cards[order[0]] || busy) return;
      drag = { card, x: e.clientX, y: e.clientY, moved: false, bx: card.style.getPropertyValue("--x"), by: card.style.getPropertyValue("--y") };
    });
    addEventListener("pointermove", (e) => {
      if (!drag) return;
      const dx = e.clientX - drag.x;
      const dy = e.clientY - drag.y;
      if (!drag.moved && Math.hypot(dx, dy) > 6) {
        drag.moved = true;
        drag.card.classList.remove("is-snapping");
        drag.card.classList.add("is-dragging");
      }
      if (!drag.moved) return;
      drag.card.style.setProperty("--x", `${elastic(dx)}px`);
      drag.card.style.setProperty("--y", `${elastic(dy)}px`);
    });
    function release(e, cancelled) {
      if (!drag) return;
      const d = drag;
      drag = null;
      if (!d.moved) return;
      suppressClick = true;
      setTimeout(() => (suppressClick = false), 0);
      d.card.classList.remove("is-dragging");
      const far = !cancelled && Math.hypot(e.clientX - d.x, e.clientY - d.y) >= 50;
      if (far) {
        next();
      } else {
        d.card.classList.add("is-snapping");
        d.card.style.setProperty("--x", d.bx);
        d.card.style.setProperty("--y", d.by);
        setTimeout(() => d.card.classList.remove("is-snapping"), 460);
      }
    }
    addEventListener("pointerup", (e) => release(e, false));
    addEventListener("pointercancel", (e) => release(e, true));
    stage.addEventListener(
      "click",
      (e) => {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
    stage.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      next();
    });
    if (nextBtn) {
      nextBtn.classList.replace("hidden", "grid");
      nextBtn.addEventListener("click", next);
    }
    if (hint) hint.classList.remove("hidden");
    layout();
  }
  $$("[data-pile]").forEach(initPile);
  document.addEventListener("shopify:section:load", (e) => $$("[data-pile]", e.target).forEach(initPile));

  /* ---------- Category showcase ---------- */
  function initShowcase(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";
    const items = $$("[data-show-item]", root);
    const images = $$("[data-show-image]", root);
    const captions = $$("[data-show-caption]", root);
    const frame = $("[data-show-frame]", root);
    let active = 0;
    let lastPointer = "mouse";
    let pressing = false; // a pointer press is in progress (its focus event is not keyboard focus)
    function set(i) {
      if (i === active) return;
      active = i;
      items.forEach((el, k) => el.classList.toggle("is-active", k === i));
      images.forEach((el, k) => el.classList.toggle("is-active", k === i));
      captions.forEach((el, k) => (el.hidden = k !== i));
      if (frame && images[i]) frame.href = images[i].dataset.url;
    }
    items.forEach((item, i) => {
      item.addEventListener("pointerdown", (e) => {
        lastPointer = e.pointerType;
        pressing = true;
      });
      item.addEventListener("pointerenter", (e) => e.pointerType === "mouse" && set(i));
      item.addEventListener("focus", () => !pressing && set(i));
      // On touch, the first tap shows the category; a second tap opens it.
      item.addEventListener("click", (e) => {
        pressing = false;
        if (lastPointer !== "mouse" && i !== active) {
          e.preventDefault();
          set(i);
        }
      });
      item.addEventListener("pointercancel", () => (pressing = false));
    });
    // Warm the photos so the wipe never reveals a half-loaded image.
    images.forEach((el) => el.querySelectorAll("img").forEach((img) => (img.loading = "eager")));
  }
  $$("[data-showcase]").forEach(initShowcase);
  document.addEventListener("shopify:section:load", (e) => $$("[data-showcase]", e.target).forEach(initShowcase));

  /* ---------- Orbit of steps ---------- */
  function initOrbit(root) {
    if (root.dataset.ready) return;
    const items = $$("[data-orbit-item]", root);
    const n = items.length;
    if (n < 2) return;
    root.dataset.ready = "1";
    root.classList.add("is-ready");
    const nodes = items.map((li) => $("[data-orbit-node]", li));
    const cards = items.map((li) => $("[data-orbit-card]", li));
    cards.forEach((c) => (c.hidden = true));
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let angle = 0; // degrees
    let active = -1;
    let stopped = false; // stopped by a click on the orbit (hovering never stops it)
    let visible = true;
    let raf = 0;
    let last = 0;
    let radius = 200;

    function measure() {
      radius = Math.round(Math.min(200, root.clientWidth * 0.36));
      root.style.setProperty("--r", radius + "px");
    }
    function place() {
      items.forEach((li, i) => {
        const deg = ((i / n) * 360 + angle) % 360;
        const rad = (deg * Math.PI) / 180;
        const x = radius * Math.cos(rad);
        const y = radius * Math.sin(rad);
        li.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px)`;
        // Front of the orbit (bottom) is brightest and on top, as in the original.
        li.style.zIndex = i === active ? 200 : Math.round(100 + 50 * Math.cos(rad));
        li.style.opacity = i === active ? 1 : Math.max(0.4, Math.min(1, 0.4 + 0.6 * ((1 + Math.sin(rad)) / 2))).toFixed(2);
      });
    }
    const spinning = () => active < 0 && !stopped && visible && !reduced;
    function tick(t) {
      const dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
      last = t;
      angle = (angle + 6 * dt) % 360; // 0.3 degrees per 50 ms
      place();
      raf = spinning() ? requestAnimationFrame(tick) : 0;
      if (!raf) last = 0;
    }
    function run() {
      if (!raf && spinning()) raf = requestAnimationFrame(tick);
    }
    function jump() {
      root.classList.add("is-jumping");
      clearTimeout(root._jump);
      root._jump = setTimeout(() => root.classList.remove("is-jumping"), 720);
    }
    function open(i) {
      active = i;
      angle = (((270 - (i / n) * 360) % 360) + 360) % 360; // bring it to the top
      jump();
      items.forEach((li, k) => {
        const on = k === i;
        li.classList.toggle("is-active", on);
        li.classList.toggle("is-related", Math.abs(k - i) === 1);
        nodes[k].setAttribute("aria-expanded", String(on));
        cards[k].hidden = !on;
      });
      place();
    }
    function close() {
      if (active < 0) return;
      active = -1;
      stopped = false;
      items.forEach((li, k) => {
        li.classList.remove("is-active", "is-related");
        nodes[k].setAttribute("aria-expanded", "false");
        cards[k].hidden = true;
      });
      place();
      run();
    }
    nodes.forEach((btn, i) =>
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (active === i) close();
        else open(i);
      })
    );
    $$("[data-orbit-go]", root).forEach((b) =>
      b.addEventListener("click", (e) => {
        e.stopPropagation();
        const i = Number(b.dataset.orbitGo);
        open(i);
        nodes[i].focus({ preventScroll: true });
      })
    );
    cards.forEach((c) => c.addEventListener("click", (e) => e.stopPropagation()));
    // A click on empty space closes an open step (and it turns again); with no step
    // open, a click stops the orbit where it is and the next click sets it moving.
    root.addEventListener("click", () => {
      if (active >= 0) return close();
      stopped = !stopped;
      run();
    });
    root.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && active >= 0) {
        const i = active;
        close();
        nodes[i].focus({ preventScroll: true });
      }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        run();
      }).observe(root);
    }
    addEventListener("resize", () => {
      measure();
      place();
    });
    measure();
    place();
    run();
  }
  $$("[data-orbit]").forEach(initOrbit);
  document.addEventListener("shopify:section:load", (e) => $$("[data-orbit]", e.target).forEach(initOrbit));

  /* ---------- Animated search bar: types phrases in turn ---------- */
  (() => {
    const header = $("[data-header]");
    const targets = $$("[data-typer-text]");
    if (!header || !targets.length) return;
    let phrases = [];
    try {
      phrases = JSON.parse(header.dataset.typerPhrases || "[]").filter(Boolean);
    } catch (e) {}
    if (!phrases.length) return;
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
    const show = (t) => targets.forEach((el) => (el.textContent = t));
    let p = 0;
    let i = phrases[0].length; // the first phrase is already on the page
    let deleting = true;
    let timer = 0;
    function step() {
      if (document.hidden) return; // resumes on visibilitychange
      const word = phrases[p];
      let wait;
      if (reduced) {
        // No typing motion: swap whole phrases.
        p = (p + 1) % phrases.length;
        show(phrases[p]);
        wait = 2800;
      } else if (deleting) {
        i -= 1;
        show(word.slice(0, i));
        if (i <= 0) {
          deleting = false;
          p = (p + 1) % phrases.length;
          wait = 350;
        } else wait = 28;
      } else {
        i += 1;
        show(phrases[p].slice(0, i));
        if (i >= phrases[p].length) {
          deleting = true;
          wait = 1800; // hold the full phrase
        } else wait = 55 + Math.random() * 45; // a human rhythm
      }
      timer = setTimeout(step, wait);
    }
    timer = setTimeout(step, 1800);
    let wasHidden = document.hidden;
    document.addEventListener("visibilitychange", () => {
      if (document.hidden === wasHidden) return; // repeat events: leave the rhythm alone
      wasHidden = document.hidden;
      clearTimeout(timer);
      if (!document.hidden) timer = setTimeout(step, 400);
    });
    // The pill is the field: click in and type; results drop down beneath it.
    $$("[data-searchbar]").forEach((bar) => {
      const input = $("[data-searchbar-input]", bar);
      const drop = $("[data-searchbar-drop]", bar);
      const open = () => (drop.hidden = false);
      const close = () => (drop.hidden = true);
      bar.addEventListener("click", () => {
        input.focus();
        open();
      });
      input.addEventListener("focus", open);
      input.addEventListener("input", () => {
        bar.classList.toggle("has-value", input.value !== "");
        open();
      });
      bar.addEventListener("focusout", (e) => {
        if (!bar.contains(e.relatedTarget)) close();
      });
      bar.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          close();
          input.blur();
        }
      });
      document.addEventListener("pointerdown", (e) => {
        if (!bar.contains(e.target)) close();
      });
    });
  })();

  // Keyboard vs pointer: [data-kbd] on <html> after a Tab press (search pill ring, reel pause).
  document.addEventListener("keydown", (e) => {
    if (e.key === "Tab") document.documentElement.dataset.kbd = "";
  });
  document.addEventListener("pointerdown", () => delete document.documentElement.dataset.kbd);

  /* ---------- Recently viewed ---------- */
  $$("[data-recently-viewed]").forEach(async (section) => {
    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem("ln-recent") || "[]");
    } catch {}
    const exclude = section.dataset.exclude;
    handles = handles.filter((h) => h && h !== exclude).slice(0, Number(section.dataset.limit) || 4);
    if (!handles.length) return;
    const cards = await Promise.all(
      handles.map((h) =>
        fetch(`${L.routes.root}products/${encodeURIComponent(h)}?view=ln-card`)
          .then((r) => (r.ok ? r.text() : ""))
          .catch(() => "")
      )
    );
    const html = cards.filter((c) => c.includes("<article")).map((c) => `<li>${c}</li>`).join("");
    if (!html) return;
    $("[data-recent-list]", section).innerHTML = html;
    section.hidden = false;
  });

  /* ---------- Moving type: keyboard pause button (never pauses on hover) ---------- */
  $$("[data-marquee-toggle]").forEach((btn) => {
    const band = btn.closest("[data-marquee]");
    btn.addEventListener("click", () => {
      const paused = band.classList.toggle("is-paused");
      btn.setAttribute("aria-pressed", String(paused));
      btn.textContent = paused ? "Play moving text" : "Pause moving text";
    });
  });

  /* ---------- Scroll reveal ---------- */
  const reveals = $$("[data-reveal]");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-revealed");
            io.unobserve(e.target);
          }
        }),
      { rootMargin: "0px 0px -10% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add("is-revealed"));
})();
